import { Component } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { ExternalLinkDirective } from '../../directives/external-link.directive';

@Component({
  selector: 'bnpp-indx-menubar',
  imports: [RouterLinkActive, RouterLink,ExternalLinkDirective],
  templateUrl: './menubar.component.html',
  styleUrl: './menubar.component.scss',
  standalone: true,
})
export class MenubarComponent {}
